export default __webpack_public_path__ + "static/media/Icon_Patreon.52bb1255.svg";